<template>
  <div class="ownerGoods">
    <div class="ownerGoods_header brl4" v-if="info">
      <!-- 名字 -->
      <div class="owner_name">
        <span class="mand-ellipsis">{{info.name}}</span>
        <span @click="handleEditOwner"><i class="iconfont icon-bianji" style="color:#31b158"></i></span>
      </div>
      <!-- 搜索 -->
      <div class="list_search">
        <input type="text" v-model="listQuery.goods_name" @input="handleBatchSearch()" placeholder="搜索商品名称" />
        <span class="icon_search"><i class="iconfont icon-sousuo" style="color:#888"></i></span>
        <span class="icon_close" v-if="listQuery.goods_name" @click="listQuery.goods_name = '';handleBatchSearch()">
          <i class="iconfont icon-guanbi" style="color:#888"></i>
        </span>
      </div>
    </div>
    <!-- 右边货主详情模块 -->
    <div class="ownerGoods_list brtl4">
      <div class="list_box">
        <md-scroll-view
          ref="goodsScrollView"
          :scrolling-x="false"
          @refreshing="handleGoodsListRefresh"
          @end-reached="handleGoodsMore"
        >
          <md-scroll-view-refresh
            roller-color="#31B158"
            slot="refresh"
            slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
            :scroll-top="scrollTop"
            :is-refreshing="isRefreshing"
            :is-refresh-active="isRefreshActive"
          ></md-scroll-view-refresh>
          <div class="goods_list">
            <div
              class="goods_list_item"
              v-for="(item,index) in list"
              :key="index"
              @click="handleDetailPop(item)"
            >
              <div class="name">
                <div class="g_name mand-ellipsis">
                  <span v-for="(good_item,good_index) in item.goods" :key="good_index">
                    <template v-if="good_index!=0">、</template>
                    {{good_item.name}}
                  </span>
                </div>
                <div class="o_name">
                  <div class="goods_item_type" style="margin-left:0">
                    <span class="item_type_zy" v-if="item.type == 1">自营</span>
                    <span class="item_type_dm" v-if="item.type == 2">代卖</span>
                  </div>
                </div>
              </div>
              <div class="money">
                <div><span>￥</span>{{Number(item.batch_amount)}}</div>
                <div>总货款</div>
              </div>
              <div class="time">
                <div style="font-size:0.2rem;color:#999;font-weight:normal">操作员：{{item.realname}}</div>
                <div>{{item.created_at | toTime}}</div>
              </div>
              <span class="arrow">
                <i class="iconfont icon-next"></i>
              </span>
              <div class="is_sale" v-if="item.is_sale != 1">
                <img src="./../../../assets/img/work/stock/stock_saleoff.png" alt="">
              </div>
            </div>
          </div>
          <md-scroll-view-more :finished-text="list.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="isFinished"></md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>
    <!-- 添加货主 -->
    <addOwner ref="addOwner" @finish="handleFinish"></addOwner>
    <!-- 批次详情 -->
    <batchDetail ref="batchDetail" @finish="handleFinish"></batchDetail>
  </div>
</template>

<script>
import { ownerBatch_list }  from "@/api/work/owner";
import addOwner from "./addOwner";
import batchDetail from "./batchDetail";
export default {
  name: 'ownerGoods',
  components:{addOwner,batchDetail},
  data(){
    return {
      info:null,
      isFinished: false,
      // 左边数据
      listQuery:{
        supplier_id:'',
        page:1,
        pageSize:15,
        goods_name:'',
        from_time:'',
        to_time:'',
      },
      list:[],
    }
  },
  created(){
    
  },
  mounted(){




  },
  methods:{
    // id
    showBox(item){
      this.info = item
      this.listQuery.supplier_id = item.id
      this.listQuery.page = 1
      this.list = item.batch_data || []
      this.getList()
    },
    // 获取货主列表
    getList() {
      ownerBatch_list(this.listQuery).then(res=>{
        if(res.code == 200 ){
          if (this.listQuery.page == 1) this.list = [];
          this.list = this.list.concat(res.data.list);
          if ( this.list.length >= res.data.totalCount || res.data.list.length == 0 ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.listQuery.page++;
          }
          this.$nextTick(()=>{
            this.$refs.goodsScrollView.finishRefresh()
            this.$refs.goodsScrollView.finishLoadMore()
          })
        }
      })
    },
    // 下拉刷新数据
    handleGoodsListRefresh() {
      this.listQuery.page = 1;
      setTimeout(()=>{
        this.getList()
      },500)
    },
    // 上拉加载更多数据
    handleGoodsMore() {
      if (this.isFinished) {
        return
      }
      this.getList()
    },
    // 输入框搜索
    handleBatchSearch(){
      this.listQuery.page = 1;
      this.getList()
    },
    // 点击了某一个批次
    handleDetailPop(item){
      this.$refs.batchDetail.showPop(item)
    },
    // 弹窗修改完成
    handleFinish(){
      this.$emit("finish")
    },
    
    // 修改信息
    handleEditOwner(){
      this.$refs.addOwner.showPop(this.info)
    },
  }
}
</script>

<style lang="less" scoped>
.ownerGoods{
  position: relative;
  overflow: hidden;
  height: 100%;
  .ownerGoods_header{
    height: 0.6rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 0.1rem;
    .owner_name{
      font-size: 0.26rem;
      font-weight: bold;  
      padding: 0 0.3rem 0 0.15rem;
      span:nth-child(1){
        display: inline-block;
        max-width: 3rem;
        margin-bottom: 0.05rem;
      }
      span{
        margin-right: 0.2rem;
        vertical-align: middle;
        i{
          font-weight: normal;
          font-size: 0.24rem;
        }
      }
    }
    .list_search{
      width: 4rem;
    }
  }
  .ownerGoods_list{
    width: 100%;
    height: calc(100% - 0.7rem);
    background-color: #fff;
    .list_box{
      height: 100%;
      .goods_list{
        padding: 0 0.15rem;
        .goods_list_item{
          height: 1rem;
          border-bottom: 0.01rem solid #e1e1e1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          &>div{
            &>div:nth-child(1){
              font-size: 0.24rem;
              line-height: 0.4rem;
              vertical-align: baseline;
              // font-weight: bold;
            }
            &>div:nth-child(2){
              font-size: 0.2rem;
              line-height: 0.32rem;
              color: #999;
            }
          }
          .name{
            width: 3.4rem;
            padding-right: 0.2rem;
          }
          .money{
            width: 3.2rem;
            padding-right: 0.2rem;
            span{
              font-size: 0.18rem;
            }
          }
          .time{
            width: 3.2rem;
            padding-right: 0.2rem;
          }
          .arrow{
            i{
              font-weight: bold;
              font-size: 0.24rem;
            }
          }
          .is_sale{
            position: absolute;
            right: 0.71rem;
            width: 0.7rem;
            height: 0.7rem;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>